module.exports = function () {
  return new Promise(function (resolve) {
    require.ensure([], function (require) {
      resolve(require("!!/home/users/mohit.mathur/metabase/node_modules/babel-loader/lib/index.js??ruleSet[1].rules[0].use[0]!/home/users/mohit.mathur/metabase/node_modules/source-map-loader/dist/cjs.js!/home/users/mohit.mathur/metabase/frontend/src/metabase-lib/metadata/utils/ga-metadata.js"));
    });
  });
}